module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutItemLine":{"available":"Dostupné","freeGift":"Dárek","freeGiftValue":"(v hodnotě {price})","notAvailable":"Nedostupné","originalPrice":"Cena před slevou {taxLabel}","pcsLeftInStock":"Na skladě je pouze {count} ks dané položky","priceWithTax":"vč. DPH","priceWithoutTax":"bez DPH","quantityDiscountFreeAmount":"{freeAmount} ks zdarma"}}}')
  delete Component.options._Ctor
}
